module.exports = __webpack_public_path__ + "img/Yotta-logo_small_dark.27f5b5.png";